<template>
  <div>
    <van-cell-group>
      <van-cell :title="addrText" is-link to="address"/>
    </van-cell-group>
    <div   v-for="item in cartList"
           :key="item.index"    class="card-goods__item">
      <van-card
          style="margin-left:15px;"
          :title="item.title"
          :desc="item.descript"
          :num="item.count"
          :price="item.price"
          :thumb="item.img"
      >
      </van-card>
    </div>
    <van-submit-bar
        :price="totalPrice"
        :button-text="submitBarText"
        @submit="handleSubmitOrder"
    />
  </div>
</template>

<script>
import {Card, Cell, CellGroup, Checkbox, CheckboxGroup, NavBar, SubmitBar, Tabbar, TabbarItem} from 'vant';

export default {
  components: {
    [Card.name]: Card,
    [Checkbox.name]: Checkbox,
    [SubmitBar.name]: SubmitBar,
    [CheckboxGroup.name]: CheckboxGroup,
    [NavBar.name]: NavBar,
    [Tabbar.name]: Tabbar,
    [TabbarItem.name]: TabbarItem,
    [Cell.name]: Cell,
    [CellGroup.name]: CellGroup
  },

  data() {
    return {
      activeFooter: 2,
      checkedGoods: [],
      checkeAllCarts: [],
      cartList: [
        {index: 1,price: 3580.00,descript: "（税控专用机）",name:"联想E73",title:"商品名称一",link:"",color:"#EA0000",count: "1"},
        {index: 2,price: "85.22",descript: "（营改增推荐税控打印机轻松应对日常开票可后进纸）",name:"中盈打印机NX-1870",title:"商品名称二",link:"",color:"#F75000",count: "1"},
        {index: 3,price: "51.42",descript: "这是一个测试商品",name:"商品名称三",title:"商品名称三",link:"",color:"#FFFF37",count: "1"},
        {index: 4,price: "46.12",descript: "这是一个测试商品",name:"商品名称四",title:"商品名称四",link:"",color:"#73BF00",count: "1"},
        {index: 5,price: "85.22",descript: "（微信或支付宝二维码识别快开 适用于NP10/NP20）",name:"凯盈扫描枪S3",title:"商品名称二",link:"",color:"#F75000",count: "1"},
      ],
      idCartList:[],
      checkedAll: true,
      addr: undefined,
      message:''
    };
  },
  // mounted() {
  //   this.idCartList = this.$route.query.ids
  //   if (typeof this.idCartList === 'string') {
  //     this.idCartList = new Array(this.idCartList);
  //   }
  //   this.init()
  // },
  computed: {
    test1(){
      console.log("test2")
      return ''
    },
    addrText(){
      return '画师(1205856544)'
    },
    submitBarText() {
      const count = this.checkedGoods.length;
      return '提交订单' + (count ? `(${count})` : '')
    },
    totalPrice() {
      return 2255.02*100
      // return this.cartList.reduce((total, item) => total + (this.checkedGoods.indexOf(item.index) !== -1 ? (parseFloat(item.price) * item.count) : 0), 0)
    },
    // },
    //
    // methods: {
    //   init() {
    //     const chosenAddressId = storage.get('chosenAddressId')
    //     order.prepareCheckout({chosenAddressId:chosenAddressId,idCarts:this.idCartList.join(',')}).then(response => {
    //       let cartList = response.data.list
    //       this.addr = response.data.addr
    //       for (let index in cartList) {
    //         cartList[index].thumb = baseApi+ '/file/getImgStream?idFile=' + cartList[index].goods.pic
    //         this.checkedGoods.push(cartList[index].id )
    //       }
    //       this.cartList = cartList
    //     }).catch((err) => {
    //       Toast(err)
    //     })
    //   },
    handleSubmitOrder(e){
      // this.$router.push({path: '/goods/'+id})
      console.log('测试')
      return ''
    },
    // submit() {
    // this.$router.push({path: '/goods/'+id})

    //   order.save({idAddress:this.addr.id,message:this.message,idCarts:this.idCartList.join(',')}).then( response => {
    //     let order = response.data

    //   })
    //   return
    // },
    //   formatPrice(price) {
    //     return (price / 100).toFixed(2);
    //   },
    //   stepperEvent(item, arg) {
    //     let count = arg[0];
    //     cart.update({id: item.id, count: count})
    //   },
    //   checkAll() {
    //     if (this.checkedGoods.length === this.cartList.length) {
    //       this.checkeAllCarts = this.checkedGoods
    //       this.checkedGoods = []
    //     } else {
    //       this.checkedGoods = this.checkeAllCarts
    //     }
    //   },
    //   chooseAddress(){
    //
    //   }
  }
};

</script>

<style lang="less">
.van-submit-bar{
  bottom:48px;
}
.card-goods {
  background-color: #fff;

  &__item {
    position: relative;
    background-color: #fafafa;

    .van-checkbox__label {
      width: 100%;
      height: auto; // temp
      padding: 0 10px 0 15px;
      box-sizing: border-box;
    }

    .van-checkbox__icon {
      top: 50%;
      left: 10px;
      z-index: 1;
      position: absolute;
      margin-top: -10px;
    }

    .van-card__price {
      color: #f44;
    }
  }
}
</style>
